// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"fe776d96","223":"34b8a7d5","265":"26f3ab4f","287":"3d1c3368","453":"ac8f629d","753":"c76f1a0c","902":"37321401"}[chunkId] + ".chunk.js";
};